<template>
	<div class="common-layout">
		<el-container>
			<el-container>
				<el-main class="Main">
					<router-view v-slot="{ Component }">
						<transition name="fade-transform" mode="out-in">
							<component :is="Component"/>
						</transition>
					</router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>

<script>
  import index from "./index-Js";
  export default index;
</script>



